import { render, staticRenderFns } from "./filingSalesArea.vue?vue&type=template&id=95ef98f6&scoped=true"
import script from "./filingSalesArea.vue?vue&type=script&lang=js"
export * from "./filingSalesArea.vue?vue&type=script&lang=js"
import style0 from "./filingSalesArea.vue?vue&type=style&index=0&id=95ef98f6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "95ef98f6",
  null
  
)

export default component.exports